<template>
    <teleport to="body">
        <div class="notification-container">
            <FloatingNotification v-for="(notification, index) in notifications" :key="notification.id"
                :message="notification.message" :type="notification.type" :duration="notification.duration"
                :persistent="notification.persistent" :style="{ top: getNotificationTop(index) + 'px' }"
                @close="removeNotification(notification.id)" />
        </div>
    </teleport>
</template>

<script>
import FloatingNotification from './FloatingNotification.vue'
import { useNotifications } from '@/composables/useNotifications'

export default {
    name: 'NotificationContainer',
    components: {
        FloatingNotification
    },
    setup() {
        const { notifications, removeNotification } = useNotifications()

        // Calculate top position for each notification to stack them from top to bottom
        const getNotificationTop = (index) => {
            const baseTop = 20 // Starting position from top
            const notificationHeight = 80 // Approximate height of each notification + margin
            return baseTop + (index * notificationHeight)
        }

        return {
            notifications,
            removeNotification,
            getNotificationTop
        }
    }
}
</script>

<style scoped>
.notification-container {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 1000;
    pointer-events: none;
}

.notification-container>* {
    pointer-events: auto;
}
</style>